'use client';

import { Tooltip as MuiTooltip } from '@mui/material';

import { useTheme } from '../../theme';
import { Typography } from '../Typography';

import {
  TOOLTIP_ENTER_TOUCH_DELAY,
  TOOLTIP_LEAVE_TOUCH_DELAY,
} from './constants';
import {
  TooltipContainer,
  TooltipHelpIcon,
  TooltipTitleContainer,
} from './styled';
import { TooltipProps } from './types';

export const Tooltip = (props: TooltipProps) => {
  const { maxWidth, title, message, titleIcon, children, titleDir, ...rest } =
    props;

  const theme = useTheme();

  if (!title && !message) {
    return children;
  }

  if (message) {
    return (
      <MuiTooltip
        enterTouchDelay={TOOLTIP_ENTER_TOUCH_DELAY}
        leaveTouchDelay={TOOLTIP_LEAVE_TOUCH_DELAY}
        PopperProps={{
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                rootBoundary: 'body',
              },
            },
          ],
          sx: {
            maxWidth: maxWidth ?? undefined,
            '.MuiTooltip-tooltip': {
              background: theme.palette.surface3,
            },
          },
        }}
        title={
          <TooltipContainer>
            {title ? (
              <TooltipTitleContainer dir={titleDir}>
                {titleIcon ? titleIcon : <TooltipHelpIcon fontSize="small" />}

                <Typography
                  variant="body7"
                  color="text2"
                  component="div"
                  dir={titleDir}
                >
                  {title}
                </Typography>
              </TooltipTitleContainer>
            ) : null}
            <Typography
              component="div"
              variant="body8"
              color="text2"
              dir={titleDir}
            >
              {message}
            </Typography>
          </TooltipContainer>
        }
        {...rest}
      >
        {children}
      </MuiTooltip>
    );
  }

  return (
    <MuiTooltip
      enterTouchDelay={TOOLTIP_ENTER_TOUCH_DELAY}
      leaveTouchDelay={TOOLTIP_LEAVE_TOUCH_DELAY}
      PopperProps={{
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              rootBoundary: 'body',
            },
          },
        ],
      }}
      title={<TooltipContainer dir={titleDir}>{title}</TooltipContainer>}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
};
